import { cn } from 'src/lib/utils';

export const CustomConfigurationMessage = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'bg-[#F5FCFE] rounded-sm-5 border border-[#009CB240] flex items-center justify-center p-7.5',
        className,
      )}
    >
      <p className={'text-center text-base font-medium text-[#009CB2]'}>
        Custom configuration by CoSupport AI.
        <br /> To request edits, reach out to your Account Manager.
      </p>
    </div>
  );
};
